<template>
  <div class="fix-width" v-if="!success">
    <h1>{{ __('Byt lösenord') }}</h1>
    <input
      type="password"
      v-model="$v.oldPassword.$model"
      :placeholder="__('Nuvarande lösenord')"
      :class="{ warning: $v.oldPassword.$invalid && $v.oldPassword.$dirty }"
    />
    <input
      type="password"
      v-model="$v.newPassword.$model"
      :placeholder="__('Nytt lösenord')"
      :class="{ warning: $v.newPassword.$invalid && $v.newPassword.$dirty }"
    />
    <input
      type="password"
      v-model="$v.newPasswordConfirm.$model"
      :placeholder="__('Upprepa nytt lösenord')"
      class="margin-bottom-x3"
    />

    <el-message warning class="margin-bottom-x2" v-if="warningMessage">
      {{ warningMessage }}
    </el-message>
    <el-message danger class="margin-bottom-x2" v-if="errorMessage">
      {{ errorMessage }}
    </el-message>
    <el-message info class="margin-bottom-x2" v-if="infoMessage">
      {{ infoMessage }}
    </el-message>

    <div class="row">
      <button @click="() => $router.go(-1)" class="button button-snd">
        {{ __('Avbryt') }}
      </button>
      <button
        @click="() => changePassword()"
        class="button"
        :disabled="$v.$invalid"
      >
        {{ __('Spara lösenord') }}
      </button>
    </div>
    <el-loader margin-top v-if="isLoading" />
  </div>
  <div v-else class="success">
    <h1>{{ __('Lyckades!') }}</h1>
    <p class="margin-bottom-x2">{{ __('Ditt lösenord har uppdaterats') }}.</p>
    <button class="button" @click="() => this.$router.push('/')">
      {{ __('Tillbaka') }}
    </button>
  </div>
</template>
<script>
import logScope from 'log-scope'
import { required } from 'vuelidate/lib/validators'
import auth from '@/services/auth'
const log = logScope('EditPassword')

export default {
  data () {
    return {
      isLoading: false,
      warningMessage: '',
      infoMessage: '',
      errorMessage: '',
      success: false,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
  },
  validations: {
    oldPassword: {
      required,
    },
    newPassword: {
      required,
    },
    newPasswordConfirm: {
      required,
    },
  },
  methods: {
    reset () {
      this.success = false
      this.isLoading = false
      this.warningMessage = ''
      this.infoMessage = ''
      this.errorMessage = ''
    },
    async changePassword () {
      try {
        this.reset()
        this.isLoading = true
        await auth.changeUserPasswordAsync(
          this.currentUser.email,
          this.oldPassword,
          this.newPassword,
          this.newPasswordConfirm
        )
        this.success = true
      } catch (err) {
        this.isLoading = false
        this.errorMessage = this.__(err.message || err)
        log.error('Could not log in', err)
      }
    },
  },
}
</script>
